import { AnyValuesDistinctItem } from '@api/catalog';

import Radio from '@components/controls/Radio';

import { colors, scale } from '@scripts/gds';

import { FilterItem } from './types';

interface CheckboxSearchProps {
    items?: FilterItem[];
    withSearch: boolean;
    anyCollection?: {
        isAnyCollection?: boolean;
        items?: AnyValuesDistinctItem[];
    };
}

const RadioFilters = ({
    items,
    anyCollection = {
        isAnyCollection: false,
        items: [],
    },
    ...props
}: CheckboxSearchProps) => {
    return (
        <div
            css={{
                maxHeight: scale(20),
                overflowY: 'auto',
                '::-webkit-scrollbar': {
                    width: 3,
                    height: 3,
                    backgroundColor: '#E0E5E7',

                    '&-thumb': {
                        backgroundColor: colors.textSecondGrey,
                    },
                },
            }}
        >
            <Radio {...props}>
                {anyCollection.isAnyCollection
                    ? anyCollection.items?.map(item => (
                          <Radio.Item
                              value={String(item.id)}
                              key={item.id}
                              css={{
                                  marginTop: scale(1),
                                  display: 'block',
                              }}
                          >
                              {item.name}
                          </Radio.Item>
                      ))
                    : items?.map(item => (
                          <Radio.Item
                              value={String(item.code)}
                              key={item.code}
                              css={{
                                  marginTop: scale(1),
                                  display: 'block',
                              }}
                          >
                              {item.name}
                          </Radio.Item>
                      ))}
            </Radio>
        </div>
    );
};

export default RadioFilters;
